import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getTaskMetrics } from '../../services'
import { SystemMetricsQueryKey } from '../../../keys'
import { GetTaskMetricsRequest, GetTaskMetricsResponse } from '../../../type'

export default function useQueryGetTaskMetrics(
	params: GetTaskMetricsRequest,
	props?: Omit<UseQueryOptions<GetTaskMetricsResponse>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		queryKey: [SystemMetricsQueryKey.GetTaskMetrics, params],
		queryFn: () => getTaskMetrics(params),
		enabled: !!params.taskId,
		refetchInterval: 30000, // Refetch every 30 seconds
		...props,
	})
}
